import { useMemo } from 'react'

import { UrlStateStorageKeys } from 'modules/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/url-state-storage/useHashedSearchParams'
import { Channel, TimeScale, VolumeComparisonType } from 'types'

import { TicketsVolumeDetailsControls } from '../TicketsVolumeDetailsContext'
import { getBaseDimensionValue } from '../utils/getBaseDimensionValue'

import { useTimeRangeData } from './useTimeRangeData'

export const useTicketsVolumeState = (channel: Channel, contextKey: string) => {
  const { calculateTimeRangeParams } = useTimeRangeData({
    timeRangePages: [],
    currentTimeRangeIndex: 0,
  })

  const initialState = useMemo(() => {
    const initialTimeRange = calculateTimeRangeParams({
      timeScale: TimeScale.Hourly,
      timeframeFilter: undefined,
      supportsFuture: true,
    })

    return {
      timeScale: TimeScale.Hourly,
      comparisonType: VolumeComparisonType.LastWeek,
      aggregationDimension: getBaseDimensionValue(channel),
      ...initialTimeRange,
    }
  }, [channel, calculateTimeRangeParams])

  return useHashedSearchParams<TicketsVolumeDetailsControls>({
    hashParamKey: UrlStateStorageKeys.TicketVolumeControls,
    initialState,
    contextKey,
  })
}
